// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1YMLC","sendOtp":"AuthorizeToLogin_sendOtp__2A_Fp"};